module.exports = __webpack_public_path__ + "img/11.4001ec9b.jpg";